// source: static/PrintData.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function () { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.AvailablePrinters', null, global);
goog.exportSymbol('proto.CustomPrintData', null, global);
goog.exportSymbol('proto.PrintData', null, global);
goog.exportSymbol('proto.PrintRawData', null, global);
goog.exportSymbol('proto.PrintRawData.Type', null, global);
goog.exportSymbol('proto.Printer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PrintData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PrintData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PrintData.displayName = 'proto.PrintData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Printer = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Printer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Printer.displayName = 'proto.Printer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AvailablePrinters = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.AvailablePrinters.repeatedFields_, null);
};
goog.inherits(proto.AvailablePrinters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AvailablePrinters.displayName = 'proto.AvailablePrinters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PrintRawData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PrintRawData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PrintRawData.displayName = 'proto.PrintRawData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CustomPrintData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.CustomPrintData.repeatedFields_, null);
};
goog.inherits(proto.CustomPrintData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CustomPrintData.displayName = 'proto.CustomPrintData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.PrintData.prototype.toObject = function (opt_includeInstance) {
    return proto.PrintData.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.PrintData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.PrintData.toObject = function (includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      datetime: jspb.Message.getFieldWithDefault(msg, 3, ""),
      group: jspb.Message.getFieldWithDefault(msg, 4, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PrintData}
 */
proto.PrintData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PrintData;
  return proto.PrintData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PrintData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PrintData}
 */
proto.PrintData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDatetime(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setGroup(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PrintData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.PrintData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PrintData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PrintData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDatetime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.PrintData.prototype.getId = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrintData} returns this
 */
proto.PrintData.prototype.setId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.PrintData.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrintData} returns this
 */
proto.PrintData.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string datetime = 3;
 * @return {string}
 */
proto.PrintData.prototype.getDatetime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrintData} returns this
 */
proto.PrintData.prototype.setDatetime = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group = 4;
 * @return {string}
 */
proto.PrintData.prototype.getGroup = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrintData} returns this
 */
proto.PrintData.prototype.setGroup = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Printer.prototype.toObject = function (opt_includeInstance) {
    return proto.Printer.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Printer} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Printer.toObject = function (includeInstance, msg) {
    var f, obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      address: jspb.Message.getFieldWithDefault(msg, 2, ""),
      rsii: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Printer}
 */
proto.Printer.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Printer;
  return proto.Printer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Printer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Printer}
 */
proto.Printer.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRsii(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Printer.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Printer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Printer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Printer.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRsii();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Printer.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Printer} returns this
 */
proto.Printer.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.Printer.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Printer} returns this
 */
proto.Printer.prototype.setAddress = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 rsii = 3;
 * @return {number}
 */
proto.Printer.prototype.getRsii = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Printer} returns this
 */
proto.Printer.prototype.setRsii = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.AvailablePrinters.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.AvailablePrinters.prototype.toObject = function (opt_includeInstance) {
    return proto.AvailablePrinters.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.AvailablePrinters} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.AvailablePrinters.toObject = function (includeInstance, msg) {
    var f, obj = {
      printersList: jspb.Message.toObjectList(msg.getPrintersList(),
        proto.Printer.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AvailablePrinters}
 */
proto.AvailablePrinters.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AvailablePrinters;
  return proto.AvailablePrinters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AvailablePrinters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AvailablePrinters}
 */
proto.AvailablePrinters.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.Printer;
        reader.readMessage(value, proto.Printer.deserializeBinaryFromReader);
        msg.addPrinters(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AvailablePrinters.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.AvailablePrinters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AvailablePrinters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AvailablePrinters.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPrintersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Printer.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Printer printers = 1;
 * @return {!Array<!proto.Printer>}
 */
proto.AvailablePrinters.prototype.getPrintersList = function () {
  return /** @type{!Array<!proto.Printer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Printer, 1));
};


/**
 * @param {!Array<!proto.Printer>} value
 * @return {!proto.AvailablePrinters} returns this
*/
proto.AvailablePrinters.prototype.setPrintersList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Printer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Printer}
 */
proto.AvailablePrinters.prototype.addPrinters = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Printer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.AvailablePrinters} returns this
 */
proto.AvailablePrinters.prototype.clearPrintersList = function () {
  return this.setPrintersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.PrintRawData.prototype.toObject = function (opt_includeInstance) {
    return proto.PrintRawData.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.PrintRawData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.PrintRawData.toObject = function (includeInstance, msg) {
    var f, obj = {
      type: jspb.Message.getFieldWithDefault(msg, 1, 0),
      content: jspb.Message.getFieldWithDefault(msg, 2, ""),
      size: jspb.Message.getFieldWithDefault(msg, 3, 0),
      x: jspb.Message.getFieldWithDefault(msg, 4, 0),
      y: jspb.Message.getFieldWithDefault(msg, 5, 0),
      rotation: jspb.Message.getFieldWithDefault(msg, 6, 0),
      align: jspb.Message.getFieldWithDefault(msg, 7, 0),
      weight: jspb.Message.getFieldWithDefault(msg, 8, 0),
      height: jspb.Message.getFieldWithDefault(msg, 9, 0),
      underline: jspb.Message.getFieldWithDefault(msg, 10, 0),
      linefeed: jspb.Message.getFieldWithDefault(msg, 11, 0),
      qrsize: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
      eec: jspb.Message.getFieldWithDefault(msg, 13, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PrintRawData}
 */
proto.PrintRawData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PrintRawData;
  return proto.PrintRawData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PrintRawData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PrintRawData}
 */
proto.PrintRawData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!proto.PrintRawData.Type} */ (reader.readEnum());
        msg.setType(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setContent(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setSize(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setX(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setY(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRotation(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setAlign(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setWeight(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setHeight(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUnderline(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setLinefeed(value);
        break;
      case 12:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setQrsize(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setEec(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PrintRawData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.PrintRawData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PrintRawData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PrintRawData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getX();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getY();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRotation();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAlign();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getUnderline();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getLinefeed();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getQrsize();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getEec();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.PrintRawData.Type = {
  TEXT: 0,
  BARCODE: 1,
  QRCODE: 2,
  IMAGE: 3
};

/**
 * optional Type type = 1;
 * @return {!proto.PrintRawData.Type}
 */
proto.PrintRawData.prototype.getType = function () {
  return /** @type {!proto.PrintRawData.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.PrintRawData.Type} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setType = function (value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.PrintRawData.prototype.getContent = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setContent = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 size = 3;
 * @return {number}
 */
proto.PrintRawData.prototype.getSize = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setSize = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 x = 4;
 * @return {number}
 */
proto.PrintRawData.prototype.getX = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setX = function (value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 y = 5;
 * @return {number}
 */
proto.PrintRawData.prototype.getY = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setY = function (value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 rotation = 6;
 * @return {number}
 */
proto.PrintRawData.prototype.getRotation = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setRotation = function (value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 align = 7;
 * @return {number}
 */
proto.PrintRawData.prototype.getAlign = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setAlign = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 weight = 8;
 * @return {number}
 */
proto.PrintRawData.prototype.getWeight = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setWeight = function (value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 height = 9;
 * @return {number}
 */
proto.PrintRawData.prototype.getHeight = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setHeight = function (value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 underline = 10;
 * @return {number}
 */
proto.PrintRawData.prototype.getUnderline = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setUnderline = function (value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 linefeed = 11;
 * @return {number}
 */
proto.PrintRawData.prototype.getLinefeed = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setLinefeed = function (value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double qrsize = 12;
 * @return {number}
 */
proto.PrintRawData.prototype.getQrsize = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setQrsize = function (value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string eec = 13;
 * @return {string}
 */
proto.PrintRawData.prototype.getEec = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrintRawData} returns this
 */
proto.PrintRawData.prototype.setEec = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.CustomPrintData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.CustomPrintData.prototype.toObject = function (opt_includeInstance) {
    return proto.CustomPrintData.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.CustomPrintData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.CustomPrintData.toObject = function (includeInstance, msg) {
    var f, obj = {
      linesList: jspb.Message.toObjectList(msg.getLinesList(),
        proto.PrintRawData.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CustomPrintData}
 */
proto.CustomPrintData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CustomPrintData;
  return proto.CustomPrintData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CustomPrintData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CustomPrintData}
 */
proto.CustomPrintData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.PrintRawData;
        reader.readMessage(value, proto.PrintRawData.deserializeBinaryFromReader);
        msg.addLines(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CustomPrintData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.CustomPrintData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CustomPrintData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CustomPrintData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.PrintRawData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PrintRawData lines = 1;
 * @return {!Array<!proto.PrintRawData>}
 */
proto.CustomPrintData.prototype.getLinesList = function () {
  return /** @type{!Array<!proto.PrintRawData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PrintRawData, 1));
};


/**
 * @param {!Array<!proto.PrintRawData>} value
 * @return {!proto.CustomPrintData} returns this
*/
proto.CustomPrintData.prototype.setLinesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PrintRawData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PrintRawData}
 */
proto.CustomPrintData.prototype.addLines = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PrintRawData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.CustomPrintData} returns this
 */
proto.CustomPrintData.prototype.clearLinesList = function () {
  return this.setLinesList([]);
};


goog.object.extend(exports, proto);
